'use client';
import { useEffect, useState } from 'react';

/**
 * 헤더 장바구니 점(`cart-dot`) — **담긴 것이 있을 때만** 그린다(2026-08-28 사용자 지시).
 * 전에는 점이 늘 붙어 있어, 비어 있어도 무언가 담긴 것처럼 보였다.
 *
 * 세는 곳은 서버(`GET /members/me/cart`)뿐이다 — 화면이 따로 세면 실물과 갈린다.
 * 담거나 뺀 자리에서 `cartChanged()` 를 부르면 헤더가 다시 센다. 층간 전달(props) 없이
 * 이벤트로 알린다 — 담는 자리가 상세·목록·장바구니로 흩어져 있어서다(토스트와 같은 방식).
 */
const EVENT = 'app:cart-changed';

/** 담거나 뺐다고 알린다 — 성공한 뒤에만 부른다 */
export function cartChanged() {
  window.dispatchEvent(new Event(EVENT));
}

/**
 * 지금 담긴 개수. `enabled` 가 false 면(비로그인) 부르지 않는다 —
 * 장바구니는 회원의 것이라 물어볼 것이 없다.
 */
export function useCartCount(enabled: boolean): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) { setCount(0); return; }
    let alive = true;
    const read = async () => {
      const res = await fetch('/api/members/me/cart').catch(() => null);
      if (!alive || !res?.ok) return;
      // 응답은 `{ cultureEnabled, currentMarketId, memberShared, rows }` 다(장바구니 화면과 같은 것)
      const body = (await res.json().catch(() => null)) as { rows?: unknown[] } | null;
      if (alive && Array.isArray(body?.rows)) setCount(body.rows.length);
    };
    void read();
    window.addEventListener(EVENT, read);
    return () => { alive = false; window.removeEventListener(EVENT, read); };
  }, [enabled]);

  return count;
}
